// extracted by mini-css-extract-plugin
module.exports = {"taxation-message-fprm-table":"taxation-message-fprm-table-0dcf32d917844b19923f32339d29d951"};